var m = Object.defineProperty;
var v = (o, e, t) => e in o ? m(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t;
var s = (o, e, t) => (v(o, typeof e != "symbol" ? e + "" : e, t), t);
class u {
  /**
   * @param sourceElement Das auslösende Element. Zum Beispiel ein Teaserbild.
   * @param targetElement Das Ziel-Element der Weiterleitung. Meistens der eigentliche Link.
   * @param config Optionen
   */
  constructor(e, t, c) {
    s(this, "sourceElement");
    s(this, "targetElement");
    s(this, "config");
    s(this, "plugins");
    this.sourceElement = e, this.targetElement = t, this.config = {
      preventDefault: !0,
      classNameActiveSource: "click-redirect-source",
      classNameActiveTarget: "click-redirect-target",
      syncFocusPlugin: {
        classNameSourceWhenTargetHasFocus: "click-redirect-source--target-has-focus",
        classNameTargetWhenSourceHasFocus: "click-redirect-target--source-has-focus"
      },
      syncHoverPlugin: {
        classNameSourceWhenTargetHasHover: "click-redirect-source--target-has-hover",
        classNameTargetWhenSourceHasHover: "click-redirect-target--source-has-hover"
      },
      ...c
    }, this.plugins = [
      new d(e, t, this.config.syncFocusPlugin),
      new E(e, t, this.config.syncHoverPlugin)
    ], this.onClick = this.onClick.bind(this);
  }
  onClick(e) {
    this.targetElement.click(), this.config.preventDefault && e.preventDefault();
  }
  /**
   * Aktiviert die Klickweiterleitung und dazugehörige EventListener
   */
  activate() {
    this.sourceElement.classList.add(this.config.classNameActiveSource), this.targetElement.classList.add(this.config.classNameActiveTarget), this.sourceElement.addEventListener("click", this.onClick), this.plugins.forEach((e) => e.activate());
  }
  /**
   * Deaktiviert die Klickweiterleitung und entfernt alle dazugehörige EventListener
   */
  deactivate() {
    this.sourceElement.classList.remove(this.config.classNameActiveSource), this.targetElement.classList.remove(this.config.classNameActiveTarget), this.sourceElement.removeEventListener("click", this.onClick), this.plugins.forEach((e) => e.deactivate());
  }
  static InitViaDom(e) {
    const t = document.querySelectorAll("[data-click-redirect]");
    return Array.from(t).map((r) => {
      const l = r.dataset.clickRedirect ? JSON.parse(r.dataset.clickRedirect.replaceAll("'", '"')) : {}, i = {
        parentSelector: ".click-redirect-parent",
        targetSelector: ".click-redirect-target",
        ...e,
        ...l
      }, h = i.parentSelector, n = r.closest(h);
      if (!n)
        throw new Error("Invalid Parent Selector");
      const g = i.targetSelector, a = n.querySelector(g);
      if (!a)
        throw new Error("Invalid Parent Selector");
      return new u(r, a, e);
    });
  }
}
class E {
  constructor(e, t, c) {
    s(this, "sourceElement");
    s(this, "targetElement");
    s(this, "config");
    this.sourceElement = e, this.targetElement = t, this.config = c, this.onSourceMouseover = this.onSourceMouseover.bind(this), this.onSourceMouseout = this.onSourceMouseout.bind(this), this.onTargetMouseover = this.onTargetMouseover.bind(this), this.onTargetMouseout = this.onTargetMouseout.bind(this);
  }
  onSourceMouseover() {
    this.targetElement.classList.add(this.config.classNameTargetWhenSourceHasHover);
  }
  onSourceMouseout() {
    this.targetElement.classList.remove(this.config.classNameTargetWhenSourceHasHover);
  }
  onTargetMouseover() {
    this.sourceElement.classList.add(this.config.classNameSourceWhenTargetHasHover);
  }
  onTargetMouseout() {
    this.sourceElement.classList.remove(this.config.classNameSourceWhenTargetHasHover);
  }
  activate() {
    this.sourceElement.addEventListener("mouseover", this.onSourceMouseover), this.sourceElement.addEventListener("mouseout", this.onSourceMouseout), this.targetElement.addEventListener("mouseover", this.onTargetMouseover), this.targetElement.addEventListener("mouseout", this.onTargetMouseout);
  }
  deactivate() {
    this.sourceElement.removeEventListener("mouseover", this.onSourceMouseover), this.sourceElement.removeEventListener("mouseout", this.onSourceMouseout), this.targetElement.removeEventListener("mouseover", this.onTargetMouseover), this.targetElement.removeEventListener("mouseout", this.onTargetMouseout), this.sourceElement.classList.remove(this.config.classNameSourceWhenTargetHasHover), this.targetElement.classList.remove(this.config.classNameTargetWhenSourceHasHover);
  }
}
class d {
  constructor(e, t, c) {
    s(this, "sourceElement");
    s(this, "targetElement");
    s(this, "config");
    this.sourceElement = e, this.targetElement = t, this.config = c, this.onSourceFocusin = this.onSourceFocusin.bind(this), this.onSourceFocusout = this.onSourceFocusout.bind(this), this.onTargetFocusin = this.onTargetFocusin.bind(this), this.onTargetFocusout = this.onTargetFocusout.bind(this);
  }
  onSourceFocusin() {
    this.targetElement.classList.add(this.config.classNameTargetWhenSourceHasFocus);
  }
  onSourceFocusout() {
    this.targetElement.classList.remove(this.config.classNameTargetWhenSourceHasFocus);
  }
  onTargetFocusin() {
    this.sourceElement.classList.add(this.config.classNameSourceWhenTargetHasFocus);
  }
  onTargetFocusout() {
    this.sourceElement.classList.remove(this.config.classNameSourceWhenTargetHasFocus);
  }
  activate() {
    this.sourceElement.addEventListener("focusin", this.onSourceFocusin), this.sourceElement.addEventListener("focusout", this.onSourceFocusout), this.targetElement.addEventListener("focusin", this.onTargetFocusin), this.targetElement.addEventListener("focusout", this.onTargetFocusout);
  }
  deactivate() {
    this.sourceElement.removeEventListener("focusin", this.onSourceFocusin), this.sourceElement.removeEventListener("focusout", this.onSourceFocusout), this.targetElement.removeEventListener("focusin", this.onTargetFocusin), this.targetElement.removeEventListener("focusout", this.onTargetFocusout), this.sourceElement.classList.remove(this.config.classNameSourceWhenTargetHasFocus), this.targetElement.classList.remove(this.config.classNameTargetWhenSourceHasFocus);
  }
}
export {
  u as ClickRedirect,
  d as ClickRedirectSyncFocusPlugin,
  E as ClickRedirectSyncHoverPlugin
};
